export default __webpack_public_path__ + "static/about-landscapes-d3ca7490d5369cb67b6e60c0c6bdcb9b.png";